import { render, staticRenderFns } from "./IdleComponent.vue?vue&type=template&id=7f832c72&scoped=true"
import script from "./IdleComponent.vue?vue&type=script&lang=js"
export * from "./IdleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f832c72",
  null
  
)

export default component.exports